import { useEffect, useState } from 'react';

const LINE_INTERVAL_MS = 90;
const MAX_REVEAL_MS = 1200;

/**
 * DD-3780: answers that used tools arrive in one piece (the API sends the text in a
 * burst when the round ends), so the newest answer is shown line by line over about a
 * second instead of appearing as a sudden wall of text. Whole lines only, so an
 * article link is never shown half-written.
 */
export const useLineReveal = (text: string, enabled: boolean): string => {
    const lines = text.split('\n');
    const [visibleLines, setVisibleLines] = useState(enabled ? 1 : lines.length);

    useEffect(() => {
        if (!enabled) {
            setVisibleLines(lines.length);
            return;
        }
        setVisibleLines(1);
        const interval = Math.min(LINE_INTERVAL_MS, MAX_REVEAL_MS / lines.length);
        const timer = setInterval(() => {
            setVisibleLines((shown) => {
                if (shown + 1 >= lines.length) {
                    clearInterval(timer);
                }
                return Math.min(shown + 1, lines.length);
            });
        }, interval);
        return () => clearInterval(timer);
    }, [text, enabled]);

    return lines.slice(0, visibleLines).join('\n');
};
